

import { Vue, Component, Prop } from 'vue-property-decorator';
import RoutePageStore from "FF/Vue/ControlCenter/Core/RoutePageStore";
import NotificationAlert from "FF/Vue/ControlCenter/Layouts/NotificationAlert/NotificationAlert.vue";

@Component({
    components: {
        NotificationAlert
    }
})
export default class HeaderBar extends Vue {
    
    @Prop({
        type: [String, Number],
        default: 0,
    }) readonly isUserLogin!: string | number;

    @Prop({
        type: Object,
        default: function() {
            return {};
        },
    }) readonly user!: {};

    @Prop({
        type: [String, Number],
        default: 0,
    }) readonly routeToPage!: string | number;

    @Prop({
        type: [String, Number],
        default: null,
    }) readonly routeToLogin!: string | number;

    @Prop({
        type: [String, Number],
        default: null,
    }) readonly hasNotification!: string | number;
    
    @Prop({
        type: [String, Number],
        default: null,
    }) readonly menuImgSrc!: string | number;

    get sidebarOpened() {
        return RoutePageStore.state.sidebarOpened;
    }
    
    set sidebarOpened(value) {
        RoutePageStore.state.sidebarOpened = value;
    }

    onMenuClick() {
        if( this.sidebarOpened )
        {
            this.sidebarOpened = false;
        }
        else
        {
            this.sidebarOpened = true;
        }
    }
    
};
